import React, { useState, useEffect, useRef } from 'react'
import { useQuery } from '@apollo/client';
import { GET_ONE_FEDERAL_RESIDENCE_DATA,
    GET_ONE_FEDERAL_RESIDENCE_DATA_PROVINCE,
    GET_ONE_FEDERAL_RESIDENCE_DATA_CANADA } from '../../../../apollo/queries';
import * as d3 from 'd3';
import './pop.css';
import ReactGA from 'react-ga';
import { doProvince } from '../../../../helpers/Utils';

const ResidencePie = (props) => {

    var data;
    var country_id = 'canada';
    var prov = doProvince(props.ld);

    const [residenceData, setResidenceData] = useState(null);
    const [residenceDataProvince, setResidenceDataProvince] = useState(null);
    const [residenceDataCanada, setResidenceDataCanada] = useState(null);
  
    const { loading2, error2, data2 } = useQuery(GET_ONE_FEDERAL_RESIDENCE_DATA, {onCompleted: setResidenceData,
        variables: { local_division:String(props.ld) }
      });
    
      const { loading8, error8, data8 } = useQuery(GET_ONE_FEDERAL_RESIDENCE_DATA_PROVINCE, {onCompleted: setResidenceDataProvince,
        variables: { province_id:String(props.ld).substr(0,2) }
      });
      
      const { loading9, error9, data9 } = useQuery(GET_ONE_FEDERAL_RESIDENCE_DATA_CANADA, {onCompleted: setResidenceDataCanada,
        variables: { country:country_id }
      });

    const parentgraph = useRef(null);
    const d3Container = useRef(null);
    const [theWidth, setTheWidth] = useState(0);
    const [theMode, setTheMode] = useState('riding');
    
    var style = {
        leftBarColor: '#6c9dc6',
        rightBarColor: '#de5454',
        tooltipBG: '#fefefe',
        tooltipColor: 'black'
    };

    const removeElementsByClass = (className) => {
        const elements = document.getElementsByClassName(className);
        while(elements.length > 0){
            elements[0].parentNode.removeChild(elements[0]);
        }
    }

    const color = d3.scaleOrdinal(d3.schemeSet3);  

    var margin = {
        top: 50,
        right: 0,
        bottom: 50,
        left: 0,
        middle: 20
    };

    const updatePie = (a) => {

        try {
            document.getElementById("pietext1").remove();
            document.getElementById("pietexttitle").remove();
            document.getElementById("pietextsubtitle").remove();
        } catch {}

        var thepiedata = {};
        var svg = d3.select(d3Container.current)

        var thedata;
        if (a === 'province') {
            setTheMode('province');
            thedata = residenceDataProvince.getFederalResidenceProvince;
            ReactGA.event({
                category: "Residence Graph",
                action: "click",
                label: "province "+props.ld,
            });            
        } else if (a === 'canada') {
            setTheMode('canada');
            thedata = residenceDataCanada.getFederalResidenceCanada;
            ReactGA.event({
                category: "Residence Graph",
                action: "click",
                label: "canada "+props.ld,
            });            
        } else {
            setTheMode('riding');
            thedata = residenceData.getFederalResidence;
            ReactGA.event({
                category: "Residence Graph",
                action: "click",
                label: "riding "+props.ld,
            });            
        }  

        for (var i=0;i<thedata.length;i++) {
            thepiedata[thedata[i].name] = thedata[i].value;
        }

        var width = parentgraph.current.offsetWidth;
        var height = 500;
        var shapemargin = 40;
        const radius = Math.min(width, height) / 2 - shapemargin;
        const bradius = Math.min(width, height) / 2 - shapemargin * 0.3;

        var tooltipDiv = d3.select("body").append("div")
        .attr("class", "tooltip")
        .style("opacity", 0);

        var totalPopulation = d3.sum(thedata, function(d) {
            return d.value;
        });

        var percentage = function(d) {
            return d / totalPopulation * 100;
        };
        
        const elements = document.getElementsByClassName("pietitle");
        while (elements.length > 0) elements[0].remove();
        removeElementsByClass("piesub");

        const pie = d3.pie()
        .value(function(d) {return d[1]; })
        .sort(function(a, b) { return d3.ascending(a.key, b.key);} )
        const data_ready = pie(Object.entries(thepiedata))

        var arcGenerator = d3.arc().innerRadius(bradius).outerRadius(bradius)

        function arcTween(a) { //<-- a is the datum bound to each arc
            var startAngle = a.startAngle; //<-- keep reference to start angle
            var i = d3.interpolate(a.startAngle, a.endAngle); //<-- interpolate start to end
            return function(t) {
              return arcGenerator({ //<-- return arc at each iteration from start to interpolate end
                startAngle: startAngle,
                endAngle: i(t)
              });
            };
          }

        const radialScale = d3.scaleLinear()
        .domain([0, 1])
        .range([0, 2 * Math.PI]);

        var updatedpie = d3.select("#paths")
        .selectAll("path")
        .data(data_ready)
        .join('path')        
        .on("mouseover", function(event, d) {
            tooltipDiv.transition()
                .duration(200)
                .style("opacity", 0.9);
            tooltipDiv.html("<strong>"+percentage(d.value).toFixed(2)+"%</strong>")
                .style("left", (event.pageX) + "px")
                .style("top", (event.pageY - 28) + "px");
        })
        .on("mouseout", function(d) {
            tooltipDiv.transition()
                .duration(500)
                .style("opacity", 0);
        })
        //.transition()
        //.duration(500)
        .attr('fill', function(d){ return(color(d.data[1])) })
        .attr('d', d3.arc()
            .innerRadius(0)
            .outerRadius(radius)
        )
        .attr("stroke", "white")
        .style("stroke-width", "2px")
        .style("opacity", 1)     

        var updatetext = svg.append("g")
        .attr("font-family", "sans-serif")
        .attr("id", "pietext1")
        .attr("font-size", 12)
        .attr("text-anchor", "middle")
        .attr('fill', 'currentColor')
        .selectAll("text")
        .data(data_ready)
        .join("text")
        .attr("transform", function(d) { return "translate(" + [theWidth/2+arcGenerator.centroid(d)[0], height/2+arcGenerator.centroid(d)[1]] + ")"; })
        .call(text => text.append("tspan")
            .attr('class','pietitle')
            .attr("id", "pietexttitle")
            .attr("y", "-0.4em")
            .attr("font-weight", "bold")
            .text(d => d.data[1] > 0 ? d.data[0] : ""))
        .call(text => text.filter(d => (d.endAngle - d.startAngle) > 0.0001).append("tspan")
            .attr('class','piesub')
            .attr("id", "pietextsubtitle")
            .attr("x", 0)            
            .attr("y", "0.7em")
            .attr("fill-opacity", 0.7)
            .attr('fill', 'currentColor')
            .text(d => d.data[1] > 0 ? `${d.data[1].toLocaleString()}` : ""));
    }    
        
    useEffect(
        () => {
            if (residenceData !== null && residenceDataProvince !== null && residenceDataCanada !== null && prov !== null && props.ld !== null && d3Container.current) {

                if (theMode === 'riding') {
                    data = residenceData.getFederalResidence;
                } else if (theMode === 'province') {
                    data = residenceDataProvince.getFederalResidenceProvince;
                } else {
                    data = residenceDataCanada.getFederalResidenceCanada;
                }

                var width = parentgraph.current.offsetWidth;
                var height = 500;
                var shapemargin = 40;

                const radius = Math.min(width, height) / 2 - shapemargin;
                const bradius = Math.min(width, height) / 2 - shapemargin * 0.3;
            
                var arcGenerator = d3.arc().innerRadius(bradius).outerRadius(bradius)
                var piedata = {};    
                const color = d3.scaleOrdinal(d3.schemeSet3);  

                var tooltipDiv = d3.select("body").append("div")
                .attr("class", "tooltip")
                .style("opacity", 0);

                var percentage = function(d) {
                    return d / totalPopulation * 100;
                };
            
                var totalPopulation = d3.sum(data, function(d) {
                    return d.value;
                });
                
                for (var i=0;i<data.length;i++) {
                    piedata[data[i].name] = data[i].value;
                }

                window.addEventListener("resize", handleResize);

                function handleResize() {
                    try {
                        document.getElementById("pietext1").remove();
                        document.getElementById("pietexttitle").remove();
                        document.getElementById("pietextsubtitle").remove();
                    } catch {}                    
                    setTheWidth(parentgraph.current.getBoundingClientRect().width);
                    try {
                        // document.getElementById("residentpie").remove();
                        if (document.getElementById("paths") !== null) {
                            var element = document.getElementById("paths");
                            element.parentNode.removeChild(element);
                        }
                        if (document.getElementById("core") !== null) {
                            document.getElementById("core").remove();
                        }
                        if (document.getElementById("pietitle") !== null) {
                            document.getElementById("pietitle").remove();
                            document.getElementById("piesub").remove();
                        }
                        
                    } catch (err) {
                        console.log(err);
                    }

                    var svg;
                    if (theWidth > 0) {
                        svg = d3.select(d3Container.current)
                        .attr("width", theWidth)
                        .attr("height", (height - margin.top + margin.bottom))
                        .append("g")
                        .attr('id','core')
                        .attr("transform", `translate(${theWidth/2}, ${height/2})`);  
                    } else {
                        svg = d3.select(d3Container.current) 
                        .attr("width", parentgraph.current.getBoundingClientRect().width)
                        .attr("height", (height - margin.top + margin.bottom))
                        .append("g")
                        .attr('id','core')
                        .attr("transform", `translate(${parentgraph.current.getBoundingClientRect().width/2}, ${height/2})`);  
                    }
                    const pie = d3.pie()
                    .value(function(d) {return d[1]; })
                    .sort(function(a, b) { return d3.ascending(a.key, b.key);} )
                    const data_ready = pie(Object.entries(piedata))
                    const u = svg
                    .attr("id","paths")
                    .selectAll("path")
                    .data(data_ready)
                    .join('path')
                    .attr('fill', function(d){ return(color(d.data[1])) })
                    .attr('d', d3.arc()
                        .innerRadius(0)
                        .outerRadius(radius)
                    )
                    .attr("stroke", "white")
                    .style("stroke-width", "2px")
                    .style("opacity", 1)
                    .on("mouseover", function(event, d) {
                        tooltipDiv.transition()
                            .duration(200)
                            .style("opacity", 0.9);
                        tooltipDiv.html("<strong>"+percentage(d.value).toFixed(2)+"%</strong>")
                            .style("left", (event.pageX) + "px")
                            .style("top", (event.pageY - 28) + "px");
                    })
                    .on("mouseout", function(d) {
                        tooltipDiv.transition()
                            .duration(500)
                            .style("opacity", 0);
                    });

                    // .transition()
                    // .duration(1000)
                    svg.append("g")
                    .attr("font-family", "sans-serif")
                    .attr("font-size", 12)
                    .attr("text-anchor", "middle")
                    .attr('fill', 'currentColor')
                    .selectAll("text")
                    .data(data_ready)
                    .join("text")
                    .attr("transform", function(d) { return "translate(" + arcGenerator.centroid(d) + ")"; })
                    .call(text => text.append("tspan")
                        .attr('class','pietitle')
                        .attr("y", "-0.4em")
                        .attr("font-weight", "bold")
                        .text(d => d.data[1] > 0 ? d.data[0] : ""))
                    .call(text => text.filter(d => (d.endAngle - d.startAngle) > 0.0001).append("tspan")
                        .attr('class','piesub')
                        .attr("x", 0)
                        .attr("y", "0.7em")
                        .attr("fill-opacity", 0.7)
                        .text(d => d.data[1] > 0 ? `${d.data[1].toLocaleString()}` : ""));    

                    width = parentgraph.current.offsetWidth - (margin.left + margin.right);
                }


                var styleSection = d3.select(d3Container.current).append('style')
                    .text(`
                        svg {
                            max-width:100%
                        }
                        .tooltip {
                            position: absolute;
                            line-height: 1.1em;
                            padding: 7px; 
                            margin: 3px;
                            background: ${style.tooltipBG}; 
                            color: ${style.tooltipColor};
                            pointer-events: none;
                            border-radius: 6px;
                        }`)

                        handleResize();

                    return () => window.removeEventListener("resize", handleResize);            
            }                    
                
        },[parentgraph, d3Container, residenceData, residenceDataProvince, residenceDataCanada])

    return (
        <div>
        {theMode === "riding" ? <button style={{marginRight:'5px'}} className="btn btn-sm btn-outline-primary active" onClick={() => updatePie('riding')}>This Riding</button> : <button style={{marginRight:'5px'}} className="btn btn-sm btn-outline-primary" onClick={() => updatePie('riding')}>This Riding</button> } 
        {theMode === "province" ? <button style={{marginRight:'5px'}} className="btn btn-sm btn-outline-primary active" onClick={() => updatePie('province')}>Province ({prov})</button> : <button style={{marginRight:'5px'}} className="btn btn-sm btn-outline-primary" onClick={() => updatePie('province')}>Province ({prov})</button> } 
        {theMode === "canada" ? <button className="btn btn-sm btn-outline-primary active" onClick={() => updatePie('canada')}>Canada</button> : <button className="btn btn-sm btn-outline-primary" onClick={() => updatePie('canada')}>Canada</button> }
        <div ref={parentgraph} style={{width:'auto', display: 'flex', flexDirection: 'column'}}>
        <svg
            className="d3-component"
            viewBox={`0 0 ${theWidth+margin.middle} 500`}
            preserveAspectRatio="xMidYMid meet"
            id="svgparent"
            ref={d3Container}
        />
        </div></div>
    )
  }
  
  export default ResidencePie;